module.exports = __webpack_public_path__ + "img/c_abc.087ccd26.jpg";